<script>
  export let percentage = 0;
</script>

<div class="progress">
  <div class="progress-bar" role="progressbar" style={`width:${percentage}%`} />
</div>
